export interface IOption {
    value: any;
    label: any;
    key?: any;
}

export class ObjectHelper {
    public static flattenObject(obj: any, parent = '', res: any = {}) {
        for (let key in obj) {
            const propName = parent ? `${key}` : key;
            if (typeof obj[key] == 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
                ObjectHelper.flattenObject(obj[key], propName, res);
            } else {
                res[propName] = obj[key];
            }
        }
        return res;
    }

    public static parseOptions(data: any): IOption[] {
        const options: IOption[] = [];
        if (!data) return options;
        Object.keys(data).forEach((k) => {
            options.push({ value: k, label: data[k], key: k });
        });
        return options;
    }
}
